import React, { useCallback, useRef } from 'react'
import { useParams } from 'react-router-dom';
import List from 'src/components/grid.component';
import { connect } from 'react-redux';
import { OperationCardAction, OperationState, OperationTaskCreationTime } from '../service';

const OperationsGrid = (props) => {
  const params = useParams();
  const gridRef = useRef(null);
  const operationState = useCallback((props) => {
    return <OperationState data={props?.dataItem} />
  }, [])
  const operationCardAction = useCallback((props) => {
    return <OperationCardAction data={props?.dataItem} />
  }, [])
  const operationTaskCreationTime = useCallback((props) => {
    return <OperationTaskCreationTime data={props?.dataItem} />
  }, [])
  const customcells = {
    "cardAction": operationCardAction,
    "taskCreationTime": operationTaskCreationTime,
    "state": operationState,
  };
  const renderCustomCell = useCallback((props, column) => {
    if (customcells[column.field]) {
      return customcells[column.field](props);
    }
  }, [customcells]);
  return (
    <div className=''>
      <List
        url={process.env.REACT_APP_GRID_API + `api/CardsManageService/Tasks/${params?.id}`}
        pSize={10}
        className="custom-grid"
        ref={gridRef}
        showExcelExport={props?.isExcelexport}
        pKey={"Opearations"}
        screenName={'Card_ Operations'}
        renderCustomCell={renderCustomCell}
        showDisplayColumns={false}
      />
    </div>
  )
}
const connectStateToProps = ({ oidc }) => {
  return { userDetails: oidc?.profile.profile }
}
export default connect(connectStateToProps)(OperationsGrid);